import { Call } from './../../../../../sharedTypes/call';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-call-dialog',
  templateUrl: './call-dialog.component.html',
  styleUrls: ['./call-dialog.component.scss'],
  standalone: false
})
export class CallDialogComponent implements OnInit {
    constructor(
        private dialogRef: MatDialogRef<CallDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { call: Call },
    ) {}

    ngOnInit(): void {}
}
